import Swal from 'sweetalert2';
import $http from '../../../../axios-instance';
import $http_ari from '../../../../axios-instance-ari';

/**
 * Obtener estándares
 */
export async function obtenerFichaDeControl({dispatch, commit}, {id_tarea, id_empresa}) {

    commit('establecerIdEmpresa', id_empresa);

    await $http_ari.get('fichas-control/' + id_tarea + '/' + id_empresa)
        .then(async (response) => {
            commit('establecerFichaDeControl', response.data.ficha_de_control);
            await dispatch('obtenerRecomendaciones');
            commit('establecerRecomendacionesFichaDeControl', response.data.ficha_de_control);
        });
}


/**
 * Obtener estándares
 */
export async function obtenerEstandares({commit, state}) {
    if (!state.estandares.length) {
        await $http_ari.get('estandares-fichas-control', {params: state.filtros})
            .then((response) => {
                commit('establecerEstandares', response.data.estandares);
            });
    }
}

/**
 * Obtener recomendaciones
 */
export async function obtenerRecomendaciones({commit, state}) {

    if (!!state.ficha_de_control.estandares.length) {
        const parametros = {
            params: {
                ids_estandares: state.ficha_de_control.estandares,
                id_empresa: state.id_empresa
            }
        };

        commit('establecerRecomendacionesTemporales');

        await $http_ari.get('estandares-fichas-control-ids', parametros)
            .then((response) => {
                commit('establecerRecomendaciones', response.data.estandares);
            });
    } else {
        commit('establecerRecomendaciones', []);
        commit('establecerRecomendacionesTemporales');
    }
}

/**
 * Obtener la tarea
 */
export async function obtenerTarea({commit}, {id_tarea, id_empresa}) {
    await $http_ari.get('analisis-de-riesgos/tareas/' + id_tarea + '?id_empresa=' + id_empresa)
        .then((response) => {
            commit('establecerTarea', response.data.data);
        });
}

/**
 * Guardar ficha de control
 */
export async function guardarFichaDeControl({state, commit}) {

    commit('dashboard/load', true, {root: true});

    commit('establecerFichaDeControlRecomendaciones');

    await $http_ari.post('fichas-control', state.ficha_de_control)
        .then(async (response) => {
            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: response.data.mensaje,
                showConfirmButton: false,
                timer: 2000
            });
        });
    commit('dashboard/load', false, {root: true});
}
